import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const FadeUp = ({ children, delay = 0, y = 40, className = "", amount = 0.15 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`font-display text-[11px] tracking-widest2 uppercase ${light ? "text-brass" : "text-brass-deep"}`}>
    {children}
  </p>
);
